/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Presentation_Template_Master_LayoutsInputs */



/**
* | output |
* | --- |
* | "{count} layouts detected" |
*
* @param {Presentation_Template_Master_LayoutsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_layouts = /** @type {((inputs: Presentation_Template_Master_LayoutsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_LayoutsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Layouts erkannt`)
	return /** @type {LocalizedString} */ (`${i?.count} layouts detected`)
});